import { AtLeastOne, IApiFilter, IKeyValue, IStyleConfig } from '@fareye/types'
import { RouteComponentProps } from 'react-router'

// Valid Alert Pages.
enum ValidAlertPages {
  alertSettings = 'alertSettings'
}

export type TAlertConfig = {
  [key in ValidAlertPages]: AtLeastOne<IPageConfig>
}

enum ValidAlertChildren {
  addAlert = 'addAlert',
  deleteAlert = 'deleteAlert',
  listAlert = 'listAlert',
  listAlertReport = 'listAlertReport',
  downloadReport = 'downloadReport'
}

export interface ISpecificKey {
  diffState: Partial<RouteAndMenuObject>
  formikProps: any
}

export interface IPageConfig {
  config: IAlertConfig
  styling: Partial<IStyleConfig<any>>
  children: TAlertChildrenConfig
  baseUrl: string
}

export type TAlertChildrenConfig = {
  [key in ValidAlertChildren]: IPageConfig | {}
}
export interface IAlertConfig extends IReactTableColumns {
  apiConfig?: IApiFilter
  selectedAlertType?: string
  constant?: Partial<TAlertConstant>
  alertListing?: IKeyValue<IAlertTypeDataConfig>
  showTimezone?: boolean
}

interface IAlertTypeDataConfig {
  formBuilderConfig: any
  reportConfig: { selectedColumns: IColumnConfig[] }
  reportFilters?: any
}

interface IReactTableColumns {
  columns?: Array<string>
}

type TConstant =
  | 'updateStatusUrlPathName'
  | 'subscriptionListingHeader'
  | 'apiFailErrorMessage'

type TAlertConstant = {
  [key in TConstant]: string
}

export interface IAlerts {
  label: string
  link: string
  order: number
}

export interface IModuleRenderingConfig extends RouteComponentProps {
  routesConfig: any
  config: IPageConfig | IChildFilterRenderingConfig
}
export interface IChildFilterRenderingConfig {
  config: IApiConfig
  styling: Partial<IStyleConfig<any>>
  children: TChildUserConfigs
  baseUrl: string
}

export enum ValidConfig {
  listChildUser = 'listChildUser',
  listChildFilter = 'listChildFilter'
}

export type TChildUserConfigs = {
  [key in ValidConfig]: IChildUserConfig
}

export type TValidConfigId = 'listChildUser' | 'listChildFilter'

export interface IChildUserConfig {
  label: string
  id: TValidConfigId
  config: IChildUserRenderingConfig
  styling: IStyleConfig<any>
}
export interface IChildUserRenderingConfig {
  children: IKeyValue<IChildrenFilterConfig>
}
export interface IChildrenFilterConfig {
  apiConfig: IApiConfig
  selectedColumns?: string[]
  formRenderingConfig?: any
}
export interface IApiConfig {
  [key: string]: {
    apiUrl: string
    queryParams?: string
    selectedColumns?: string[]
  }
}

export interface IColumn {
  label: string
  key: string
  formatter?: (val: any) => string
  link?: string
}

export interface IColumnConfig extends Pick<IColumn, 'label' | 'key'> {
  formatter?: string
  link?: string
}
// ================ Config Mgmt ==================== //
export enum ConfigType {
  'Routes & Menu' = 'routesAndMenu',
  'Alerts & Reports' = 'alertsAndReports',
  'Page Rendering' = 'pageRenderingConfig'
}

export enum EnvTypes {
  'localhost' = 'http://localhost:3001/api/v1/records',
  'transportation.fareye.co' = 'http://transportation.fareye.co/api/v1/records',
  'transportation-test.fareye.co' = 'http://transportation-test.fareye.co/api/v1/records',
  'tpt-qa.fareye.co' = 'http://tpt-qa.fareye.co/api/v1/records',
  'tpt-staging1.fareye.co' = 'http://tpt-staging1.fareye.co/api/v1/records',
  'tpt-staging2.fareye.co' = 'http://tpt-staging2.fareye.co/api/v1/records'
}

export enum CRUDModes {
  ADD = 'add',
  Update = 'update',
  Delete = 'Delete'
}

export interface RouteAndMenuObject {
  id: number
  authenticated: boolean
  bLabel: string
  children: RouteAndMenuObject[]
  exact: boolean
  key: string
  label: string
  layout: Array<'header' | 'sidebar'>
  link: string
  path: string
  parent?: any
}
